import { NotesConfigurationModel } from "@/Patient/Models/NotesConfigurationModel";

class NotesConfigurationSettings {
    [key: string]: NotesConfigurationModel;

    constructor(fields?: Partial<NotesConfigurationSettings>) {
        Object.assign(this, fields);
    }
}

export { NotesConfigurationSettings };
